import { useSelector } from 'react-redux'
import { ColumnCellWithCollapse } from './ColumnCellWithCollapse'

export const FirstColumnCell = ({
  ids,
  rowId,
  val,
  style,
  selectRowData,
  selectChildIds,
  selectParentIds,
  changeIds,
}) => {
  const rowData = useSelector(selectRowData(rowId))

  const fieldStyle = rowData.fieldStyle || ''
  const childIds = useSelector(selectChildIds(rowId))
  const parentId = useSelector(selectParentIds(rowId))

  return (
    <div
      style={{
        minWidth: 200,
        paddingLeft: !parentId && childIds.length === 0 ? '14px' : '0px',
      }}
      className="dFlex justifyContentBetween alignItemsCenter"
    >
      <ColumnCellWithCollapse
        ids={ids}
        rowId={rowId}
        val={val}
        style={style}
        childIds={childIds}
        parentId={parentId}
        changeIds={changeIds}
        fieldStyle={fieldStyle}
      />
    </div>
  )
}
